const toSafeNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
};

export const deriveCartCount = (payload, fallback = 0) => {
    if (Array.isArray(payload)) {
        return payload.length;
    }

    const directCount = toSafeNumber(payload);
    if (directCount !== null) {
        return directCount;
    }

    if (!payload || typeof payload !== 'object') {
        return fallback;
    }

    if (Array.isArray(payload.cart_products)) {
        return payload.cart_products.length;
    }

    if (Array.isArray(payload.cart?.cart_products)) {
        return payload.cart.cart_products.length;
    }

    const prioritizedCounts = [
        payload.no_of_cart_products,
        payload.cart?.no_of_products,
        payload.no_of_products,
    ];

    for (const value of prioritizedCounts) {
        const count = toSafeNumber(value);
        if (count !== null) {
            return count;
        }
    }

    return fallback;
};
